import { Box, Grid, Typography } from "@material-ui/core";
import { FiUpload } from "react-icons/fi";
import { SiMicrosoftexcel } from "react-icons/si";
import HighlightOffIcon from "@material-ui/icons/HighlightOff";

import { COLORS } from "../../../../theme/colors";
import { UploadButton } from "../../../../components/base";
import { EXCEL_FILE_TYPE } from "../../../../constants";

export const UploadDataStep = ({ selectedFile, setSelectedFile }) => {
  return (
    <Box
      borderRadius={8}
      bgcolor={COLORS.darks[0][10]}
      height="100%"
      minHeight={300}
      pt={10}
      boxSizing="border-box"
    >
      <Box margin="auto" width="fit-content" pb={5} position="relative">
        {selectedFile ? (
          <>
            <SiMicrosoftexcel style={{ color: COLORS.purple, fontSize: 60 }} />
            <HighlightOffIcon
              style={{ position: "absolute", top: -8, right: -10 }}
              onClick={() => setSelectedFile()}
            />
          </>
        ) : (
          <FiUpload style={{ color: COLORS.purple, fontSize: 60 }} />
        )}
      </Box>

      {selectedFile ? (
        <Typography variant="h4" align="center" color="primary">
          {selectedFile.name}
        </Typography>
      ) : (
        <Grid container alignItems="center" justifyContent="center" style={{ columnGap: 4 }}>
          <Typography variant="h4">Please</Typography>
          <UploadButton
            textStyle={{ fontSize: 18, fontWeight: 400, lineHeight: "24px" }}
            text="upload the building data excel"
            onlyText={true}
            accept={EXCEL_FILE_TYPE}
            onChange={(e) => setSelectedFile(e.target.files[0])}
          />
          <Typography variant="h4">once you have filled it out</Typography>
        </Grid>
      )}
    </Box>
  );
};
